import * as React from 'react';

import PropTypes from 'prop-types';
// @ts-expect-error
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

// @ts-expect-error
import Retracked from 'js/app/retracked';

// @ts-expect-error
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!pages/saml-sso/styl/all';

type Props = {
  requestCountryCode: string;
  csrfToken: string;
  children: React.ReactNode;
};

class SamlSsoApplication extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    csrfToken: PropTypes.string,
    requestCountryCode: PropTypes.string,
  };

  static statics = {
    storeListeners: [ApplicationStore],
  };

  getChildContext() {
    const { csrfToken, requestCountryCode } = this.props;
    return { csrfToken, requestCountryCode };
  }

  render() {
    const { children } = this.props;
    return <div className="rc-SamlSsoApplication">{children}</div>;
  }
}

const TrackedSamlSsoApplication = Retracked.createTrackedContainer(({ params }) => ({
  namespace: {
    app: 'saml_sso',
    page: 'saml_sso',
  },
  params,
}))(SamlSsoApplication);

export default connectToStores(['ApplicationStore'], (context) => ({
  csrfToken: context.ApplicationStore.getState().csrfToken,
  requestCountryCode: context.ApplicationStore.getState().requestCountryCode,
}))(TrackedSamlSsoApplication);
